export { HOST, HOST_SECOND, HOST_CMS, HOST_WEB } from "./API";
export { IMAGE, defaultImage, contractorImage } from "./dummy";



// WEBPACK FOOTER //
// ./src/constants/index.js